import { render, staticRenderFns } from "./HostedRegistrationPayment.vue?vue&type=template&id=400246cd"
import script from "./HostedRegistrationPayment.vue?vue&type=script&lang=ts"
export * from "./HostedRegistrationPayment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports